import * as React from "react";
import { forwardRef } from "react";
const SvgAdd = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8 3.077c.34 0 .616.276.616.616v3.692h3.692a.615.615 0 1 1 0 1.23H8.616v3.693a.615.615 0 1 1-1.231 0V8.616H3.693a.615.615 0 0 1 0-1.231h3.692V3.693c0-.34.275-.616.615-.616", fill: "#737B7E" }));
const ForwardRef = forwardRef(SvgAdd);
export { ForwardRef as ReactComponent };
